export const TOOLTIP_VIEW_LIMIT = 3;
